import { createSlice } from "@reduxjs/toolkit";
import { defaultPageSize } from "../../../components/authZTable";
import { loadAppTabsMetaData } from "./appTabsLocalStorage";

export const usersTab = { id: "users", name: "User's Access", showMyList: false };
export const reviewTab = { id: "review", name: "Reviews", showMyList: false };
export const appInfoTab = { id: "appInfo", name: "App Info", showMyList: false };
export const activeTabKey = "activeTab";
export const submitPreviewKey = "submitPreview";
export const activeColumnsKey = "activeColumns";
export const appInfoColumnsKey = "appInfoTableColumn";

const initialState = {
  appTabs: loadAppTabsMetaData(),
};

export const ApplicationDetailsSlice = createSlice({
  name: "applicationDetails",
  initialState,
  reducers: {
    setMyListSwitch(state, action) {
      let { tabId, name, appId, show, active } = action.payload;
      if (!(appId in state.appTabs)) {
        state.appTabs[appId] = {};
      }
      state.appTabs[appId][tabId] = { ...state.appTabs[appId][tabId], tabId, name, show, active };
    },
    setActiveColumns(state, action) {
      let { appId, ...rest } = action.payload; // rest is totalColumns, selectedColumns and pinned columns
      if (!(appId in state.appTabs)) {
        state.appTabs[appId] = {};
      }
      state.appTabs[appId][activeColumnsKey] = {
        ...state.appTabs[appId][activeColumnsKey],
        ...rest,
      };
    },
    setTabPageSize(state, action) {
      let { tabId, appId, pageSize } = action.payload;
      if (!(appId in state.appTabs)) {
        state.appTabs[appId] = {};
      }
      state.appTabs[appId][tabId] = { ...state.appTabs[appId][tabId], tabId, pageSize };
    },
    setAppInfoActiveColumns(state, action) {
      let { appId, totalColumns, selectedColumns } = action.payload;
      if (!(appId in state.appTabs)) {
        state.appTabs[appId] = {};
      }
      state.appTabs[appId][appInfoColumnsKey] = {
        ...state.appTabs[appId][appInfoColumnsKey],
        totalColumns,
        selectedColumns,
      };
    },
    resetAppTabMetaData(state) {
      state.appTabs = loadAppTabsMetaData();
    },
  },
});

export const findActiveTab = (state, appId) =>
  state.appTabs[appId]?.[activeTabKey] ?? usersTab + "-" + appId;

export const getTotalColumns = (state, appId) =>
  state.appTabs[appId]?.[activeColumnsKey]?.totalColumns ?? [];
export const getSelectedColumns = (state, appId) =>
  state.appTabs[appId]?.[activeColumnsKey]?.selectedColumns ?? [];
export const getPinnedColumns = (state, appId) =>
    state.appTabs[appId]?.[activeColumnsKey]?.pinnedColumns ?? [];
export const getAppInfoTabSelectedColumns = (state, appId) =>
  state.appTabs[appId]?.[appInfoColumnsKey]?.selectedColumns ?? [];
export const getAppInfoTabTotalColumns = (state, appId) =>
  state.appTabs[appId]?.[appInfoColumnsKey]?.totalColumns ?? [];

export const showMyTasksFilter = (state, appId, tabId) => state.appTabs[appId]?.[tabId]?.show;
export const getTabPageSize = (state, appId, tabId) =>
  state.appTabs[appId]?.[tabId]?.pageSize ?? defaultPageSize;
export const ApplicationDetailsReducer = ApplicationDetailsSlice.reducer;
const {
  setActiveTab,
  setMyListSwitch,
  setTabPageSize,
  setActiveColumns,
  setAppInfoActiveColumns,
  resetAppTabMetaData,
} = ApplicationDetailsSlice.actions;
export const ApplicationDetailsActions = {
  setActiveTab,
  setMyListSwitch,
  setTabPageSize,
  setActiveColumns,
  setAppInfoActiveColumns,
  resetAppTabMetaData,
};
